import { useParams, useNavigate, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useStore } from '../../store/database';
import { TIER_ORDER, TIER_LABELS } from '../../config/house.config';
import type { SupportedLang } from '../../config/house.config';

export default function ReleaseDetailPage() {
  const { slug } = useParams();
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const release = useStore(s => s.releases.find(r => r.slug === slug && !r.deleted_at));
  const member = useStore(s => s.getMember());
  const _log = useStore(s => s._log);
  const lang = i18n.language as SupportedLang;

  if (!release) {
    return (
      <div className="space-y-4 py-12 text-center">
        <p className="font-serif text-xl text-charcoal/50">{t('common.notFound')}</p>
        <Link to="/releases" className="text-[11px] tracking-widest uppercase font-sans text-charcoal/40 hover:text-charcoal">{t('common.backList')} →</Link>
      </div>
    );
  }

  const tr = release.translations[lang] || release.translations.en;
  const tierIdx = member ? TIER_ORDER.indexOf(member.access_tier) : -1;
  const hasAccess = release.eligible_tiers.some(et => TIER_ORDER.indexOf(et) <= tierIdx);

  // Log view
  if (member && hasAccess) _log(member.id, 'release_viewed', { release_id: release.id });

  return (
    <div className="max-w-2xl space-y-6">
      <button onClick={() => navigate('/releases')} className="text-[10px] tracking-widest uppercase font-sans text-charcoal/30 hover:text-charcoal transition-colors">
        ← {t('common.backList')}
      </button>

      <div className="space-y-4">
        <p className="text-[10px] tracking-widest uppercase text-charcoal/20 font-sans">{release.house_category_slug}</p>
        <h1 className="font-serif text-3xl">{tr.title}</h1>

        {hasAccess ? (
          <div className="space-y-4">
            <p className="text-sm font-sans text-charcoal/70 leading-relaxed whitespace-pre-line">{tr.content}</p>
            {release.window_start && release.window_end && (
              <p className="text-[10px] text-charcoal/30 font-sans">{t('releases.accessWindow')}: {new Date(release.window_start).toLocaleDateString()} – {new Date(release.window_end).toLocaleDateString()}</p>
            )}
          </div>
        ) : (
          <div className="relative">
            <div className="blur-sm select-none">
              <p className="text-sm font-sans text-charcoal/70 leading-relaxed">{tr.content.substring(0, 60)}...</p>
            </div>
            <div className="absolute inset-0 flex flex-col items-center justify-center bg-ivory/80">
              <div className="text-center space-y-3">
                <p className="text-[10px] tracking-widest-xl uppercase text-gold font-sans">🔒 {t('releases.locked')}</p>
                <button onClick={() => navigate('/membership')} className="text-[11px] tracking-widest uppercase font-sans border-b border-charcoal/20 pb-0.5 hover:border-charcoal transition-colors">
                  {t('nav.membership')} →
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
